import store from "services/store";

import Validator from "services/validator";
import { Missing, isKubernetesName, MaxLength } from "services/validator/rules";
import createActions from "modules/form/actions";

import {
  cloudAccountFetcher,
  cloudAccountFormModal,
} from "state/cloudaccounts/services";
import { createAccount } from "state/cloudaccounts/actions/create";

const validator = new Validator();
validator.addRule(["name", "secretKey", "secretId"], Missing());
validator.addRule(["name"], isKubernetesName());
validator.addRule(["name"], MaxLength(32));

async function submit(data) {
  const { name, description, secretId, secretKey } = data;

  const payload = {
    metadata: {
      name,
      annotations: {
        description,
      },
    },
    spec: {
      secretId: secretId?.trim(),
      secretKey: secretKey?.trim(),
    },
  };

  return store.dispatch(createAccount("tencent", payload));
}

async function init() {
  let data;
  if (cloudAccountFormModal?.data?.uid) {
    data = await store.dispatch(cloudAccountFetcher.fetch());
    store.dispatch({
      type: "SET_ACCOUNT_AS_VALID",
    });
  }

  return Promise.resolve({
    name: data?.metadata.name || "",
    description: data?.metadata?.annotations?.description || "",
    secretId: data?.spec?.secretId || "",
    secretKey: data?.spec?.secretKey || "",
  });
}

export const tencentAccountFormActions = createActions({
  submit,
  validator,
  init,
});
